@if (ProposalRequestFormGroup && Company) {
  <div class="container-fluid p-0">
    <ng-template
      #ProposalRequestVendorCollection
      let-ProposalRequestVendorsFormArray="ProposalRequestVendorsFormArray"
      let-emptyMessage="emptyMessage"
    >
      @if (ProposalRequestVendorsFormArray.controls.length === 0) {
        <p class="text-secondary mb-0">{{ emptyMessage }}</p>
      }

      @if (ProposalRequestVendorsFormArray.controls.length > 0) {
        <div class="row g-3">
          @for (
            ProposalRequestVendorForm of ProposalRequestVendorsFormArray.controls;
            track ProposalRequestVendorForm;
            let index = $index
          ) {
            <div class="col-md-6">
              <div class="vendor-card">
                <div class="vendor-card__head">
                  <div class="vendor-card__name">
                    {{ ProposalRequestVendorForm.value.legalName }}
                  </div>
                  @if (ProposalRequestVendorForm.value.dba) {
                    <div class="vendor-card__dba">
                      DBA: {{ ProposalRequestVendorForm.value.dba }}
                    </div>
                  }
                </div>

                <dl class="vendor-card__details">
                  <div class="vendor-card__row">
                    <dt>Bid contact</dt>
                    <dd>
                      {{ ProposalRequestVendorForm.value.firstName }}
                      {{ ProposalRequestVendorForm.value.lastName }}
                    </dd>
                  </div>
                  @if (ProposalRequestVendorForm.value.email) {
                    <div class="vendor-card__row">
                      <dt>Email</dt>
                      <dd>
                        <span class="text-break">{{
                          ProposalRequestVendorForm.value.email
                            .split(',')[0]
                            .trim()
                        }}</span>
                        @if (
                          ProposalRequestVendorForm.value.email.includes(',')
                        ) {
                          <span
                            class="chip chip-info ms-2"
                            [ngbTooltip]="ProposalRequestVendorForm.value.email"
                            placement="top"
                            container="body"
                          >
                            +{{
                              ProposalRequestVendorForm.value.email.split(',')
                                .length - 1
                            }}
                            more
                          </span>
                        }
                      </dd>
                    </div>
                  }
                  <div class="vendor-card__row">
                    <dt>Phone</dt>
                    <dd>{{ ProposalRequestVendorForm.value.phone }}</dd>
                  </div>
                  @if (ProposalRequestVendorForm.value.phone2) {
                    <div class="vendor-card__row">
                      <dt>Work phone</dt>
                      <dd>
                        {{ ProposalRequestVendorForm.value.phone2Ext }}
                        {{ ProposalRequestVendorForm.value.phone2 }}
                      </dd>
                    </div>
                  }
                </dl>

                <div class="action-row justify-end vendor-card__actions">
                  <button
                    type="button"
                    class="btn btn-outline btn-sm"
                    (click)="
                      removeVendor(ProposalRequestVendorsFormArray, index)
                    "
                    [disabled]="disableInput"
                  >
                    Remove
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    (click)="editVendor(ProposalRequestVendorForm)"
                  >
                    Edit
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </ng-template>

    <!-- VIVE vendors -->
    <div class="row mb-3">
      <div class="col">
        <app-display-card [innerPanel]="true">
          <div class="qsb-section-head">
            <h3 class="mb-0">VIVE vendors</h3>
            <button
              type="button"
              class="btn btn-outline btn-sm"
              (click)="addViveVendor()"
              [disabled]="disableInput"
            >
              <i class="bi bi-plus-lg me-1"></i>
              Add VIVE vendor(s)
            </button>
          </div>

          <ng-container
            *ngTemplateOutlet="
              ProposalRequestVendorCollection;
              context: {
                ProposalRequestVendorsFormArray:
                  ViveProposalRequestVendorsFormArray,
                emptyMessage:
                  'No VIVE vendors added yet. Use the button above to invite vendors already in VIVE.'
              }
            "
          ></ng-container>
        </app-display-card>
      </div>
    </div>

    <!-- Unregistered vendors -->
    <div class="row">
      <div class="col">
        <app-display-card [innerPanel]="true">
          <div class="qsb-section-head">
            <h3 class="mb-0">Unregistered vendors</h3>
            <button
              type="button"
              class="btn btn-outline btn-sm"
              (click)="addNonViveVendor()"
              [disabled]="disableInput"
            >
              <i class="bi bi-plus-lg me-1"></i>
              Add unregistered vendor(s)
            </button>
          </div>

          <ng-container
            *ngTemplateOutlet="
              ProposalRequestVendorCollection;
              context: {
                ProposalRequestVendorsFormArray:
                  NonViveProposalRequestVendorsFormArray,
                emptyMessage:
                  'No unregistered vendors added yet. Use the button above to invite vendors not yet in VIVE.'
              }
            "
          ></ng-container>
        </app-display-card>
      </div>
    </div>
  </div>
}
